<script>
import {
  Line
} from 'vue-chartjs'
export default {
  extends: Line,
  props: ['data', 'options'],
  watch: {
    data(val) {
      this.renderChart(val, this.opt);
    }
  },
  computed: {
    opt() {
      let options = Object.assign({}, this.options);
      if ((options.legend || {}).display) {
        options.legend.onHover = function(e) {
          e.target.style.cursor = 'pointer';
        };
        options.legend.onLeave = function(e) {
          e.target.style.cursor = 'default';
        };
      }
      return options;
    }
  },
  mounted() {
    this.renderChart(this.data, this.opt);
  }
}
</script>
